import React, { useState, useEffect } from 'react';

const ManufacturerForm = ({ manufacturer, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    manufacturer_name: '',
    manufacturer_address: '',
    manufacturer_contact_info: ''
  });

  useEffect(() => {
    if (manufacturer) {
      setFormData({
        manufacturer_name: manufacturer.manufacturer_name || '',
        manufacturer_address: manufacturer.manufacturer_address || '',
        manufacturer_contact_info: manufacturer.manufacturer_contact_info || ''
      });
    }
  }, [manufacturer]);

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Name:
        <input name="manufacturer_name" value={formData.manufacturer_name} onChange={handleChange} required />
      </label>
      <label>
        Address:
        <input name="manufacturer_address" value={formData.manufacturer_address} onChange={handleChange} />
      </label>
      <label>
        Contact Info:
        <input name="manufacturer_contact_info" value={formData.manufacturer_contact_info} onChange={handleChange} />
      </label>
      <button type="submit">Save</button>
      <button type="button" onClick={onCancel}>Cancel</button>
    </form>
  );
};

export default ManufacturerForm;